import { render, staticRenderFns } from "./ShainToroku.vue?vue&type=template&id=a99b04fe&scoped=true"
import script from "./ShainToroku.vue?vue&type=script&lang=js"
export * from "./ShainToroku.vue?vue&type=script&lang=js"
import style0 from "./ShainToroku.vue?vue&type=style&index=0&id=a99b04fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99b04fe",
  null
  
)

export default component.exports